export default __webpack_public_path__ + "static/media/7.70770ef4.jpeg";